var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayed)?_c('iw-input-checkbox',{staticClass:"field",attrs:{"input-label":_vm.$t('is_there_a_sauna'),"name":"has-sauna"},model:{value:(_vm.hasSauna),callback:function ($$v) {_vm.hasSauna=$$v},expression:"hasSauna"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }